// test1807
(1807 && 0);
